import Vue from 'vue'
import * as d from './data-dictionary'

Vue.directive('to-camelcase', {
  twoWay: true,
  bind: function (el) {
    el.value = el.value.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}).replace(/\s+/g, " ");
  },
  update: function (el) {

    el.value = el.value.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}).replace(/\s+/g, " ");
  },
  unbind: function (el) {
    el.value = ''
  }
})


Vue.directive('generics', {
  twoWay: true,
  bind: function (el) {
    
  },
  update: function (el) {
    
  },
  unbind: function (el) {
    el.value = ''
  }
})

Vue.directive('to-uppercase', {
  twoWay: true,
  bind: function (el) {
    el.value = el.value.toUpperCase();
  },
  update: function (el) {
    el.value = el.value.toUpperCase();
  },
  unbind: function (el) {
    el.value = ''
  }
})